// extracted by mini-css-extract-plugin
module.exports = {"main":"VerticalBarChartStyles_main__3WZAQ","graph":"VerticalBarChartStyles_graph__3NuF5","graphHeader":"VerticalBarChartStyles_graphHeader__2VAwh"};